var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-6"},[_c('a-modal',{attrs:{"title":"ยืนยันการส่ง SMS","visible":_vm.smsConfirmationVisibility,"maskClosable":false,"okText":"ส่ง","cancelText":"ยกเลิก"},on:{"ok":_vm.send,"cancel":function($event){_vm.smsConfirmationVisibility = false}}},[_c('p',{staticClass:"font-bold mb-2"},[_vm._v(" คุณต้องการส่ง SMS ไปยังผู้รับกลุ่มต่างๆหรือไม่ ")])]),_c('h1',{staticClass:"text-2xl font-bold mb-4"},[_vm._v("ส่ง SMS แจ้งเตือน")]),_c('div',[_c('a-form-item',{attrs:{"label":"เลือกกลุ่มผู้รับ (เลือกได้มากกว่า 1 กลุ่ม)","validate-status":!_vm.$v.forms.targets.required && _vm.$v.forms.targets.$dirty
          ? 'error'
          : 'success',"help":!_vm.$v.forms.targets.required && _vm.$v.forms.targets.$dirty
          ? 'กรุณาเลือกผู้รับอย่างน้อย 1 กลุ่ม'
          : ''}},[_c('a-checkbox-group',{staticClass:"flex flex-col",attrs:{"options":[
          {
            label: ("ผู้มีความเสี่ยงสุขภาพสูง " + (_vm.assessmentGroup.risk_high) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.risk_high_users) + " คน"),
            value: 'HEALTH_HIGH_RISK',
          },
          {
            label: ("ผู้มีความเสี่ยงสุขภาพปานกลาง " + (_vm.assessmentGroup.risk_medium) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.risk_medium_users) + " คน"),
            value: 'HEALTH_MEDIUM_RISK',
          },
          {
            label: ("ผู้มีความเสี่ยงสุขภาพต่ำ " + (_vm.assessmentGroup.risk_low) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.risk_low_users) + " คน"),
            value: 'HEALTH_LOW_RISK',
          },
          {
            label: ("ผู้มีคุณภาพชีวิตที่ไม่ดี " + (_vm.assessmentGroup.quality_of_life_bad) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.quality_of_life_bad_users) + " คน"),
            value: 'WHOQOL_LOW',
          },
          {
            label: ("การมีคุณภาพชีวิตกลางๆ" + (_vm.assessmentGroup.quality_of_life_fair) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.quality_of_life_fair_users) + " คน"),
            value: 'WHOQOL_MEDIUM',
          },
          {
            label: ("การมีคุณภาพชีวิตที่ดี " + (_vm.assessmentGroup.quality_of_life_good) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.quality_of_life_good_users) + " คน"),
            value: 'WHOQOL_HIGH',
          },
          {
            label: ("ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดีมาก " + (_vm.assessmentGroup.living_very_good) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.living_very_good_users) + " คน"),
            value: 'HPLP_VERY_GOOD',
          },
          {
            label: ("ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดี " + (_vm.assessmentGroup.living_good) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.living_good_users) + " คน"),
            value: 'HPLP_GOOD',
          },
          {
            label: ("ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์พอใช้\t" + (_vm.assessmentGroup.living_fair) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.living_fair_users) + " คน"),
            value: 'HPLP_FAIR',
          },
          {
            label: ("ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ปรับปรุง " + (_vm.assessmentGroup.living_bad) + " คน, ผู้ลงทะเบียน SMS " + (_vm.assessmentGroup.living_bad_users) + " คน"),
            value: 'HPLP_BAD',
          } ]},model:{value:(_vm.$v.forms.targets.$model),callback:function ($$v) {_vm.$set(_vm.$v.forms.targets, "$model", $$v)},expression:"$v.forms.targets.$model"}})],1)],1),_c('a-form-item',{attrs:{"label":"ข้อความ","validate-status":!_vm.$v.forms.message.required && _vm.$v.forms.message.$dirty
        ? 'error'
        : 'success',"help":!_vm.$v.forms.message.required && _vm.$v.forms.message.$dirty
        ? 'กรุณาป้อนข้อความ'
        : ''}},[_c('a-textarea',{attrs:{"placeholder":"ข้อความ...","auto-size":{ minRows: 5, maxRows: 5 }},model:{value:(_vm.$v.forms.message.$model),callback:function ($$v) {_vm.$set(_vm.$v.forms.message, "$model", $$v)},expression:"$v.forms.message.$model"}})],1),_c('a-button',{attrs:{"type":"primary","block":""},on:{"click":function($event){$event.preventDefault();_vm.smsConfirmationVisibility = true}}},[_vm._v("ส่งข้อความ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }